<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div v-if="status === 'success'" class="success-container">
            <div class="title big">Payout Successful</div>
            <div class="desc">Your funds are on their way to your account.</div>
          </div>
          <div v-else-if="status === 'failure'" class="failure-container">
            <div class="title big">Payout Failed</div>
            <div class="desc">{{ message || 'An error occurred during the payout process. Please try again or contact support.' }}</div>
          </div>
          <div v-else class="pending-container">
            <div class="title big">Payout Pending</div>
            <div class="desc">{{ message || 'Your payout is being processed.' }}</div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "PayoutResultPage",
  props: {
    status: {
      type: String,
      required: true,
      validator: function (value) {
        return ['success', 'failure', 'pending'].indexOf(value) !== -1;
      },
    },
    message: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.success-container {
  color: #4caf50;
}

.failure-container {
  color: #f44336;
}

.pending-container {
  color: #ff9800;
}
</style>
